export { default } from "Explore/Components/SocialImpact/SdgDetailDrawer";
